module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "system-builder__header--section"
  }, [_c('h2', [_vm._v(_vm._s(_vm.sharedState.currentStep.title))]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__header--progress-container"
  }, [_c('ol', {
    staticClass: "progress"
  }, [_vm._l((parseInt(_vm.sharedState.currentStep.stepNumber)), function(dot) {
    return _c('li', {
      staticClass: "is-active",
      attrs: {
        "data-step": ""
      }
    })
  }), _vm._v(" "), _vm._l((_vm.numberStepsIncomplete), function(step) {
    return _c('li', {
      attrs: {
        "data-step": ""
      }
    })
  })], 2)]), _vm._v(" "), (_vm.sharedState.currentStep.stepNumber > 1) ? _c('span', {
    staticClass: "system-builder__header--back-button",
    on: {
      "click": _vm.goBackStep
    }
  }, [_vm._v("< Back")]) : _vm._e(), _vm._v(" "), (parseInt(_vm.sharedState.currentStep.stepNumber) > 1) ? _c('div', {
    staticClass: "system-builder__quick-nav"
  }, [_c('span', {
    on: {
      "click": _vm.resetBuilder
    }
  }, [_vm._v("Start Over")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1af00377","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/header.vue
// module id = 417
// module chunks = 1